import React from 'react';
import { Menu, LogOut, Check, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import * as CONST from '../constants';
import styles from './Header.module.css';

const Header = ({ toggleSidebar, selectedFarm }) => {
    const { user } = useAuth(); // Context에서 사용자 정보 가져오기

    return (<header className={styles['header']}>
        <div className={styles['header-left']}>
            <button onClick={toggleSidebar} className={styles['hamburger-button']} style={{ display: 'flex' }}>
                <Menu size={24} />
            </button>
            <h1 className={styles['header-title']}>젖소 선형심사 계획교배 시스템</h1>
        </div>

        <div className={styles['farm-info']}>
            {user?.mtype1 === CONST.USER_TYPE_FARM_OWNER ? (
                <div className={styles['farm-info-badge']} style={{ backgroundColor: '#d1fae5', color: '#065f46' }}>
                    <Check size={16} style={{ marginRight: '0.25rem' }} />
                    <span>농장주: {selectedFarm.owner}</span>
                </div>
            ) : selectedFarm.id ? (
                <div className={`${styles['farm-info-badge']} ${styles['selected']}`}>
                    <Check size={16} style={{ marginRight: '0.25rem' }} />
                    <span>선택 농장: {selectedFarm.name} ({selectedFarm.id})</span>
                </div>
            ) : (
                <div className={`${styles['farm-info-badge']} ${styles['not-selected']}`}>
                    <X size={16} style={{ marginRight: '0.25rem' }} />
                    <span>선택된 농장 없음</span>
                </div>
            )}
        </div>
    </header>);
};

export default Header;
